import * as React from "react";
const SvgIconRemove = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19 13H5V11H19V13Z", fill: "black", fillOpacity: 0.87 }));
export default SvgIconRemove;
